export default __webpack_public_path__ + "static/media/store_icon.64a0a3cc.svg";